<template>
<div class="container-fluid bg-white">
	<expense-toolbar></expense-toolbar>

	<h3><i class="fa" :class="icon ? icon : 'fa-history'"></i> Submitted Expenses</h3>

	<expense-table
		:show-user="true"
		:show-job="true"
		:editable="true"
		:filtering-tools="true"
		:filters="filters"
		:hide-info-boxes="false"
		:show-processed-buttons="true"
		:orders="[['purchase_date','DESC']]">

		<div slot="above-table" class="d-flex flex-row flex-wrap align-items-end mb-2">

			<field
				class="mr-2" 
				:params="{
					type: 'btn-group',
					tabStyling: true,
					buttons: [
						{text: 'Business',value:'business'},
						{text: 'Personal',value:'personal'}
						
					]
				}"
				v-model="selectedType">
			</field>

			<label>
				<input type="checkbox" class="checkbox" v-model="includeProcessed">
				Include processed logs
			</label>

		</div>

	</expense-table>
</div>
</template>
<script type="text/javascript">
import ExpenseToolbar from "./ExpenseToolbar"
import ExpenseTable from "@/components/super_components/ExpenseTable"

import Field from "@/components/Field"

export default {
	name: "SubmittedExpenses",
	components: {
		ExpenseToolbar,
		ExpenseTable,
		Field
	},
	data() {
		return {
			selectedType: 'business',
			includeProcessed: false
		}
	},
	computed: {
		filters() {
			let filters = [
				['reviewed_by >',0]
			]

			if (!this.includeProcessed)
				filters.push(['processed',0])

			if (this.selectedType == 'business')
				filters.push(["payment_method !=","Personal Card/Cash"])
			else
				filters.push(['payment_method','Personal Card/Cash'])

			return filters
		}
	}
}
</script>